import React from 'react';

import {ScheduleWidget, ScheduleWidgetWithModes} from './schedule-widget';

export default class ScheduleElement extends React.Component {
    componentDidMount() {
        const widget_class =
            this.props.modes != null ? ScheduleWidgetWithModes : ScheduleWidget;
        const days =
            this.props.day != null ? [''] : ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];
        this._schedule = new widget_class(days);
        this._schedule.bind('changed', (schedule) =>
            this.props.onScheduleChanged?.(schedule)
        );
        this._schedule.element().appendTo(this.container);
        this.applyProps(this.props);
    }

    applyProps(props) {
        const modes_for_schedule = {};
        this._schedule.schedule(props.tempschedule);
        if (this.props.modes != null) {
            for (let [mode_id, mode] of Object.entries(props.modes)) {
                if (mode.schedule_number != null) continue;

                modes_for_schedule['M' + mode_id] = {
                    name: mode.name,
                    temp:
                        typeof mode.zone_temp?.[1] === 'number'
                            ? mode.zone_temp[1]
                            : null,
                    color: mode.color != null ? mode.color : undefined,
                };
            }
            this._schedule.modes(modes_for_schedule);
        }
        if (this.props.show_temperature_selector != null)
            this._schedule.show_temperature_selector(
                this.props.show_temperature_selector
            );
    }

    componentDidUpdate(prevProps) {
        this.applyProps(this.props);
    }

    componentWillUnmount() {
        this._schedule.destroy();
    }

    set_container = (container) => (this.container = container);

    render() {
        return <div ref={this.set_container} />;
    }
}
